import { faqs } from "../../data/dummyData"
import SingleFaq from "./SingleFaq";

const FaqsList = () => {
  return (
    <div>
         <h1 className="heading">Sıkça Sorulan Sorular

</h1>
      {faqs.map((faq) => (
        <SingleFaq {...faq} key={faq.id} />
      ))}
    </div>
  );
};

export default FaqsList;
